import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/modals/bonus/bonus';
import {getBonus} from '../../../../../reducers/user/actions';
import Language from '../../../../../language';

export default () => {
    const {bonus_state, currency, button} = useSelector(Selector),
          dispatch = useDispatch(),
          progress = (bonus_state.daily.total_slots.amount / bonus_state.daily.total_slots.limit) * 100;

    return (
        <div className="bonus">
            <div className="text">
                {Language('modals.bonus.daily.slots')}
                <br/>
                ({bonus_state.daily.total_slots.amount}/{bonus_state.daily.total_slots.limit})
            </div>
            <div className="bonus-progress">
                <div className="progress-border"></div>
                <div className="progress-line" style={{width: `${progress > 100 ? 100 : progress}%`}}></div>
            </div>
            <div className="button-space">
                <div className="claim-button" style={{
                    opacity: (bonus_state.daily.total_slots.claimed) ? 0.7 : 1
                }} onClick={e => {
                    if(button || bonus_state.daily.total_slots.claimed)
                        return;

                    dispatch(getBonus({
                        type: 'daily',
                        bonus: 'total_slots'
                    }));
                }}>
                    {
                        (bonus_state.daily.total_slots.claimed)
                        ? Language('modals.bonus.claimed')
                        : Language('modals.bonus.get', {amount: bonus_state.daily.total_slots.bonus, currency})
                    }
                </div>
            </div>
        </div>
    )
}